module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "info-modal"
    }
  }, [_c('div', {
    staticClass: "flex-modal",
    class: {
      'animate-flex-modal': _vm.show === true, 'glow': _vm.isAtlasMode === true
    },
    attrs: {
      "id": _vm.fixedId
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('h6', [_c('strong', [_vm._v(_vm._s(_vm.$t('name')))])]), _vm._v(" "), _c('h4', {
    staticClass: "bottom-padding"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), ((_vm.description != '-') && (_vm.description != '') && (_vm.description != '<br>')) ? _c('h6', [_c('strong', [_vm._v(_vm._s(_vm.$t('description')))])]) : _vm._e(), _vm._v(" "), ((_vm.description != '-') && (_vm.description != '') && (_vm.description != '<br>')) ? _c('p', {
    staticClass: "bottom-padding",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e(), _vm._v(" "), _c('h6', [_c('strong', [_vm._v(_vm._s(_vm.$t('author')))])]), _vm._v(" "), _c('h6', {
    staticClass: "bottom-padding"
  }, [_vm._v(_vm._s(_vm.author))]), _vm._v(" "), ((_vm.tags != '-')) ? _c('h6', [_c('strong', [_vm._v(_vm._s(_vm.$t('tags')))])]) : _vm._e(), _vm._v(" "), ((_vm.tags != '-')) ? _c('p', {
    staticClass: "bottom-padding",
    domProps: {
      "innerHTML": _vm._s(_vm.tags)
    }
  }) : _vm._e(), _vm._v(" "), _c('h6', [_c('strong', [_vm._v(_vm._s(_vm.$t('creationDate')))])]), _vm._v(" "), _c('p', {
    staticClass: "bottom-padding"
  }, [_vm._v(_vm._s(_vm.creationDateF))]), _vm._v(" "), _c('h6', [_c('strong', [_vm._v(_vm._s(_vm.$t('lastUpdated')))])]), _vm._v(" "), _c('p', {
    staticClass: "bottom-padding"
  }, [_vm._v(_vm._s(_vm.lastUpdatedDate))]), _vm._v(" "), _c('div', {
    staticClass: "attribution"
  }, [_c('h6', [_c('strong', [_vm._v(_vm._s(_vm.$t('attribution')))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.attribution)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "logo-info",
    attrs: {
      "href": "//www.instamaps.cat",
      "target": _vm.isInIframe ? '_blank' : '_parent'
    }
  }, [_c('img', {
    staticClass: "instamaps-logo-info",
    attrs: {
      "src": "/static/img/instamaps-v2-logo-flat.png",
      "alt": "Logo Instamaps",
      "title": _vm.$t('menu.home')
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55500ce6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/info-modal/info-modal.vue
// module id = 133
// module chunks = 0